export default __webpack_public_path__ + "static/media/1959.243c289a.png";